export default __webpack_public_path__ + "static/media/io_main.d7d3b729.png";